<template>
    <div class="animated fadeIn lapeks-page">
        <div class="filter-card mb-3">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <h4 class="page-title mb-0">Laporan Pemasukan</h4>
                <button type="button" class="btn btn-filter-reset" name="downloadExcelBtn" :disabled="isLoading" @click="confirmPeriodeDownload()">
                    <i class="fa fa-download mr-2"></i>Download Excel
                </button>
            </div>

            <div class="filter-section">
                <div class="filter-controls-row">
                    <div class="filter-field">
                        <span class="filter-sublabel">Cabang</span>
                        <div class="filter-multiselect-wrapper">
                            <multiselect
                                name="filterCabang"
                                v-model="input.filterCabang"
                                :options="cabangOption"
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="Cabang"
                                :disabled="!showWebPeriode"
                                @input="onCabangChange"
                            />
                        </div>
                    </div>

                    <div class="filter-field">
                        <span class="filter-sublabel">Periode</span>
                        <div class="range-group">
                            <b-form-input v-model="input.filterFromDate" name="filterFromDate" type="date" class="filter-input"></b-form-input>
                            <span class="range-sep">s/d</span>
                            <b-form-input v-model="input.filterToDate" name="filterToDate" type="date" class="filter-input"></b-form-input>
                        </div>
                    </div>

                    <div class="filter-field">
                        <span class="filter-sublabel">Tipe Pinjaman</span>
                        <b-form-select v-model="input.tipePinjamanPeriode" name="tipePinjaman" :options="tipePinjamanOption" class="filter-select">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Tipe Pinjaman</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <button type="button" class="btn btn-filter-search" name="searchTableBtn" :disabled="isLoading" @click="onSearch()">
                        <i class="fa fa-search"></i>
                    </button>
                    <button type="button" class="btn btn-filter-reset" name="resetTableBtn" :disabled="isLoading || !showWebPeriode" @click="onResetAll()">Reset</button>
                </div>
            </div>
        </div>
        <div v-if="showWebPeriode">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                    <div class="laporan-periode">
                        <h4>Laporan Pemasukan <span>({{jenisTipeLaporan}}) </span></h4>
                        <h6>
                            Periode : 
                            <span>{{$helper.changeDateFormat(periodeStart)}}</span>
                            <span v-if="periodeEnd != ''"> - {{$helper.changeDateFormat(periodeEnd)}}</span>
                        </h6>
                    </div>
                </div>
                <div class="mb-4">
                    <b-form-group class="form-inline" label-for="tipePembayaran" label="Tipe Pembayaran">
                        <b-form-select class="ml-2" v-model="input.tipePembayaranPeriode" id="tipePembayaran" name="tipePinjaman" :options="tipePembayaranOption" value-field="id" text-field="name">
                        </b-form-select>
                    </b-form-group>
                </div>
                <div class="table-card">
                    <div class="table-responsive-wrapper">
                    <b-table show-empty hover
                        :busy="isBusy"
                        :items="showDataPemasukan" 
                        :fields="fields" 
                        :currentPage="currentPage" 
                        :perPage="perPage"
                        responsive class="custom-data-table mb-0">
                        <template v-slot:table-busy>
                            <div class="text-center text-muted my-4 py-3">
                                <b-spinner class="align-middle mr-2" variant="primary" small></b-spinner>
                                <span>Loading data...</span>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data pemasukan.
                        </template>
                        <template v-slot:cell(cabangName)="row">
                            <div class="no-wrap">
                                {{ row.item.cabangName }}                 
                            </div>
                        </template>
                        <template v-slot:cell(jumlahTransaksi)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahTransaksi) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(jasa)="row">
                            <div class="text-right no-wrap" v-if="row.item.jasa == null">{{$helper.addThousandSeparator(row.item.jasa)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.jasa < 0">- Rp{{$helper.addThousandSeparator(row.item.jasa).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.jasa)}} </div>
                        </template>
                        <template v-slot:cell(jasaAwal)="row">
                            <div class="text-right no-wrap" v-if="row.item.jasaAwal == null">{{$helper.addThousandSeparator(row.item.jasaAwal)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.jasaAwal < 0">- Rp{{$helper.addThousandSeparator(row.item.jasaAwal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.jasaAwal)}} </div>
                        </template>
                        <template v-slot:cell(admin)="row">
                            <div class="text-right no-wrap" v-if="row.item.admin == null">{{$helper.addThousandSeparator(row.item.admin)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.admin < 0">- Rp{{$helper.addThousandSeparator(row.item.admin).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.admin)}} </div>
                        </template>
                        <template v-slot:cell(adminAwal)="row">
                            <div class="text-right no-wrap" v-if="row.item.adminAwal == null">{{$helper.addThousandSeparator(row.item.adminAwal)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.adminAwal < 0">- Rp{{$helper.addThousandSeparator(row.item.adminAwal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.adminAwal)}} </div>
                        </template>
                        <template v-slot:cell(denda)="row">
                            <div class="text-right no-wrap" v-if="row.item.denda == null">{{$helper.addThousandSeparator(row.item.denda)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.denda < 0">- Rp{{$helper.addThousandSeparator(row.item.denda).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.denda)}} </div>
                        </template>
                        <template v-slot:cell(penalti)="row">
                            <div class="text-right no-wrap" v-if="row.item.penalti == null">{{$helper.addThousandSeparator(row.item.penalti)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.penalti < 0">- Rp{{$helper.addThousandSeparator(row.item.penalti).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.penalti)}} </div>
                        </template>
                        <template v-slot:cell(keringanan)="row">
                            <div class="text-right no-wrap" v-if="row.item.keringanan == null">{{$helper.addThousandSeparator(row.item.keringanan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.keringanan < 0">- Rp{{$helper.addThousandSeparator(row.item.keringanan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.keringanan)}} </div>
                        </template>
                        <template v-slot:cell(angsuranPokok)="row">
                            <div class="text-right no-wrap" v-if="row.item.angsuranPokok == null">{{$helper.addThousandSeparator(row.item.angsuranPokok)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.angsuranPokok < 0">- Rp{{$helper.addThousandSeparator(row.item.angsuranPokok).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.angsuranPokok)}} </div>
                        </template>
                        <template v-slot:cell(pokok)="row">
                            <div class="text-right no-wrap" v-if="row.item.pokok == null">{{$helper.addThousandSeparator(row.item.pokok)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.pokok < 0">- Rp{{$helper.addThousandSeparator(row.item.pokok).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokok)}} </div>
                        </template>
                        <template v-slot:cell(totalPemasukan)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalPemasukan == null"><strong>{{$helper.addThousandSeparator(row.item.totalPemasukan)}}</strong> </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalPemasukan < 0"><strong>- Rp{{$helper.addThousandSeparator(row.item.totalPemasukan).replace("-", "")}}</strong></div>
                            <div class="text-right no-wrap" v-else><strong>Rp. {{$helper.addThousandSeparator(row.item.totalPemasukan)}} </strong></div>
                        </template>
                        <template v-slot:custom-foot v-if="showDataPemasukan.length != 0">
                            <td class="custom-footer-wrapper"><strong>Total</strong></td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataPemasukanAll.jumlahTransaksi)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanAll.jasa == null">{{$helper.addThousandSeparator(showDataPemasukanAll.jasa)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanAll.jasa < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanAll.jasa).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanAll.jasa)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanAll.admin == null">{{$helper.addThousandSeparator(showDataPemasukanAll.admin)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanAll.admin < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanAll.admin).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanAll.admin)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanAll.denda == null">{{$helper.addThousandSeparator(showDataPemasukanAll.denda)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanAll.denda < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanAll.denda).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanAll.denda)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanAll.penalti == null">{{$helper.addThousandSeparator(showDataPemasukanAll.penalti)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanAll.penalti < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanAll.penalti).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanAll.penalti)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanAll.keringanan == null">{{$helper.addThousandSeparator(showDataPemasukanAll.keringanan)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanAll.keringanan < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanAll.keringanan).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanAll.keringanan)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanAll.totalPemasukan == null"><strong>{{$helper.addThousandSeparator(showDataPemasukanAll.totalPemasukan)}} </strong></div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanAll.totalPemasukan < 0"><strong>- Rp{{$helper.addThousandSeparator(showDataPemasukanAll.totalPemasukan).replace("-", "")}}</strong></div>
                                <div class="text-right no-wrap" v-else><strong>Rp. {{$helper.addThousandSeparator(showDataPemasukanAll.totalPemasukan)}} </strong></div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanAll.jasaAwal == null">{{$helper.addThousandSeparator(showDataPemasukanAll.jasaAwal)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanAll.jasaAwal < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanAll.jasaAwal).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanAll.jasaAwal)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanAll.adminAwal == null">{{$helper.addThousandSeparator(showDataPemasukanAll.adminAwal)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanAll.adminAwal < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanAll.adminAwal).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanAll.adminAwal)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanAll.angsuranPokok == null">{{$helper.addThousandSeparator(showDataPemasukanAll.angsuranPokok)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanAll.angsuranPokok < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanAll.angsuranPokok).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanAll.angsuranPokok)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanAll.pokok == null">{{$helper.addThousandSeparator(showDataPemasukanAll.pokok)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanAll.pokok < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanAll.pokok).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanAll.pokok)}} </div>
                            </td>
                        </template>
                    </b-table>
                    </div>
                    <p class="text-muted smallText">* Total = Jasa + Admin + Denda + Penalti + Keringanan (tidak termasuk jasa awal dan admin awal)</p>
                    <div class="table-pagination-footer d-flex align-items-center justify-content-between">
                        <div class="limit-wrapper d-flex align-items-center">
                            <span class="limit-label mr-2">Tampilkan</span>
                            <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options" class="limit-select">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="entries-info ml-3">{{ totalViewText }}</span>
                        </div>
                        <b-pagination class="custom-pagination mb-0"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                            prev-text="‹"
                            next-text="›"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!--
            ============================================================
            VARIAN "LAPORAN TAHUNAN" - dinonaktifkan.
            Referensi hanya menampilkan tabel per-cabang, jadi blok ini
            dimatikan lewat v-if="false" (bukan komentar HTML, karena
            markup di dalamnya memuat "--" yang menutup komentar).
            Kode lama tetap utuh bila nanti mau diaktifkan lagi.
            ============================================================
        -->
        <div v-if="false">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                    <div class="laporan-periode">
                        <h4>Laporan Pemasukan <span>({{jenisTipeLaporan}})</span></h4>
                        <h6>
                            Periode : Tahun {{ periodeTahun }}
                        </h6>
                    </div>
                </div>
                <div class="mb-4">
                    <b-form-group class="form-inline" label-for="tipePembayaran" label="Tipe Pembayaran">
                        <b-form-select class="ml-2" v-model="input.tipePembayaranTahunan" name="tipePembayaranTahunan" :options="tipePembayaranOption" value-field="id" text-field="name">
                        </b-form-select>
                    </b-form-group>
                </div>
                <!-- <b-row>
                    <b-col xl="3" lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="card-data">
                                    <p class="mb-0 text-muted">Jasa</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.jasa)}}
                                    </strong>
                                </div>
                                <div class="ml-2 card-icon">
                                    <i class="fa fa-handshake-o"></i>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="3" lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="card-data">
                                    <p class="mb-0 text-muted">Admin</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.admin)}}
                                    </strong>
                                </div>
                                <div class="ml-2 card-icon">
                                    <i class="fa fa-user-o"></i>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="3" lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="card-data">
                                    <p class="mb-0 text-muted">Denda</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.denda)}}
                                    </strong>
                                </div>
                                <div class="ml-2 card-icon">
                                    <i class="fa fa-minus"></i>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="3" lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="card-data">
                                    <p class="mb-0 text-muted">Penalti</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.penalti)}}
                                    </strong>
                                </div>
                                <div class="ml-2 card-icon">
                                    <i class="fa fa-fire"></i>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="3" lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="card-data">
                                    <p class="mb-0 text-muted">Keringanan</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.keringanan)}}
                                    </strong>
                                </div>
                                <div class="ml-2 card-icon">
                                    <i class="fa fa-cut"></i>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="3" lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="card-data">
                                    <p class="mb-0 text-muted">Angsuran Pokok</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.angsuranPokok)}}
                                    </strong>
                                </div>
                                <div class="ml-2 card-icon">
                                    <i class="fa fa-calendar-o"></i>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="3" lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="card-data">
                                    <p class="mb-0 text-muted">Pokok</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.pokok)}}
                                    </strong>
                                </div>
                                <div class="ml-2 card-icon">
                                    <i class="fa fa-diamond"></i>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="3" lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="card-data">
                                    <p class="mb-0 text-muted">Total</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.total)}}
                                    </strong>
                                </div>
                                <div class="ml-2 card-icon">
                                    <i class="fa fa-calculator"></i>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row> -->
                <b-card >
                    <template v-slot:header>
                        <h5>Laporan Pemasukan Cabang Tahunan</h5>
                    </template>
                    <b-table show-empty hover
                        :busy="isBusy"
                        :items="showDataPemasukanTahunan" 
                        :fields="fieldTahunan" 
                        responsive class="custom-data-table mb-0">
                        <template v-slot:table-busy>
                            <div class="text-center text-muted my-4 py-3">
                                <b-spinner class="align-middle mr-2" variant="primary" small></b-spinner>
                                <span>Loading data...</span>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data pemasukan.
                        </template>
                        <template v-slot:cell(cabangName)="row">
                            <div class="no-wrap">
                                {{ row.item.cabangName }}                 
                            </div>
                        </template>
                        <template v-slot:cell(jumlahTransaksi)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlahTransaksi) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(jasa)="row">
                            <div class="text-right no-wrap" v-if="row.item.jasa == null">{{$helper.addThousandSeparator(row.item.jasa)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.jasa < 0">- Rp{{$helper.addThousandSeparator(row.item.jasa).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.jasa)}} </div>
                        </template>
                        <template v-slot:cell(jasaAwal)="row">
                            <div class="text-right no-wrap" v-if="row.item.jasaAwal == null">{{$helper.addThousandSeparator(row.item.jasaAwal)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.jasaAwal < 0">- Rp{{$helper.addThousandSeparator(row.item.jasaAwal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.jasaAwal)}} </div>
                        </template>
                        <template v-slot:cell(admin)="row">
                            <div class="text-right no-wrap" v-if="row.item.admin == null">{{$helper.addThousandSeparator(row.item.admin)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.admin < 0">- Rp{{$helper.addThousandSeparator(row.item.admin).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.admin)}} </div>
                        </template>
                        <template v-slot:cell(adminAwal)="row">
                            <div class="text-right no-wrap" v-if="row.item.adminAwal == null">{{$helper.addThousandSeparator(row.item.adminAwal)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.adminAwal < 0">- Rp{{$helper.addThousandSeparator(row.item.adminAwal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.adminAwal)}} </div>
                        </template>
                        <template v-slot:cell(denda)="row">
                            <div class="text-right no-wrap" v-if="row.item.denda == null">{{$helper.addThousandSeparator(row.item.denda)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.denda < 0">- Rp{{$helper.addThousandSeparator(row.item.denda).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.denda)}} </div>
                        </template>
                        <template v-slot:cell(penalti)="row">
                            <div class="text-right no-wrap" v-if="row.item.penalti == null">{{$helper.addThousandSeparator(row.item.penalti)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.penalti < 0">- Rp{{$helper.addThousandSeparator(row.item.penalti).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.penalti)}} </div>
                        </template>
                        <template v-slot:cell(keringanan)="row">
                            <div class="text-right no-wrap" v-if="row.item.keringanan == null">{{$helper.addThousandSeparator(row.item.keringanan)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.keringanan < 0">- Rp{{$helper.addThousandSeparator(row.item.keringanan).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.keringanan)}} </div>
                        </template>
                        <template v-slot:cell(angsuranPokok)="row">
                            <div class="text-right no-wrap" v-if="row.item.angsuranPokok == null">{{$helper.addThousandSeparator(row.item.angsuranPokok)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.angsuranPokok < 0">- Rp{{$helper.addThousandSeparator(row.item.angsuranPokok).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.angsuranPokok)}} </div>
                        </template>
                        <template v-slot:cell(pokok)="row">
                            <div class="text-right no-wrap" v-if="row.item.pokok == null">{{$helper.addThousandSeparator(row.item.pokok)}} </div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.pokok < 0">- Rp{{$helper.addThousandSeparator(row.item.pokok).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokok)}} </div>
                        </template>
                        <template v-slot:cell(totalPemasukan)="row">
                            <div class="text-right no-wrap" v-if="row.item.totalPemasukan == null"><strong>{{$helper.addThousandSeparator(row.item.totalPemasukan)}} </strong></div>
                            <div class="text-right no-wrap text-danger" v-else-if="row.item.totalPemasukan < 0"><strong>- Rp{{$helper.addThousandSeparator(row.item.totalPemasukan).replace("-", "")}}</strong></div>
                            <div class="text-right no-wrap" v-else><strong>Rp. {{$helper.addThousandSeparator(row.item.totalPemasukan)}} </strong></div>
                        </template>
                        <template v-slot:custom-foot v-if="showDataPemasukanTahunan.length != 0">
                            <td class="custom-footer-wrapper"><strong>Total</strong></td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap">
                                    {{ $helper.addThousandSeparator(showDataPemasukanTahunanAll.jumlahTransaksi)}}
                                </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanTahunanAll.jasa == null">{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.jasa)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanTahunanAll.jasa < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.jasa).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.jasa)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanTahunanAll.admin == null">{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.admin)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanTahunanAll.admin < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.admin).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.admin)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanTahunanAll.denda == null">{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.denda)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanTahunanAll.denda < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.denda).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.denda)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanTahunanAll.penalti == null">{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.penalti)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanTahunanAll.penalti < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.penalti).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.penalti)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanTahunanAll.keringanan == null">{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.keringanan)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanTahunanAll.keringanan < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.keringanan).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.keringanan)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanTahunanAll.totalPemasukan == null"><strong>{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.totalPemasukan)}} </strong></div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanTahunanAll.totalPemasukan < 0"><strong>- Rp{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.totalPemasukan).replace("-", "")}}</strong></div>
                                <div class="text-right no-wrap" v-else><strong>Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.totalPemasukan)}} </strong></div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanTahunanAll.jasaAwal == null">{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.jasaAwal)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanTahunanAll.jasaAwal < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.jasaAwal).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.jasaAwal)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanTahunanAll.adminAwal == null">{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.adminAwal)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanTahunanAll.adminAwal < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.adminAwal).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.adminAwal)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanTahunanAll.angsuranPokok == null">{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.angsuranPokok)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanTahunanAll.angsuranPokok < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.angsuranPokok).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.angsuranPokok)}} </div>
                            </td>
                            <td class="custom-footer-wrapper">
                                <div class="text-right no-wrap" v-if="showDataPemasukanTahunanAll.pokok == null">{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.pokok)}} </div>
                                <div class="text-right no-wrap text-danger" v-else-if="showDataPemasukanTahunanAll.pokok < 0">- Rp{{$helper.addThousandSeparator(showDataPemasukanTahunanAll.pokok).replace("-", "")}}</div>
                                <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(showDataPemasukanTahunanAll.pokok)}} </div>
                            </td>
                        </template>
                    </b-table>
                    <p class="text-muted smallText mb-0">* Total = Jasa + Admin + Denda + Penalti + Keringanan (tidak termasuk jasa awal dan admin awal)</p>
                </b-card>
            </div>
        </div>

        <b-modal id="modal-periode-search" title="Laporan Periode" no-close-on-backdrop no-close-on-esc
            :hide-header-close="isSubmitting" hide-footer>
            <div class="form-content-wrapper mb-0">
                <div class="search-wrapper align-items-center justify-content-between">
                    <b-form-group
                        label="Tanggal Gadai"
                        label-for="filterInput"
                        class="form-group-wrapper mb-3"
                    >
                        <div class="d-flex search-input-wrapper">
                            <b-form-input class="mr-2"
                                v-model="input.filterFromDate" name="filterFromDate"
                                id="filterDate"
                                type="date"
                            ></b-form-input>
                            <span class="mr-2 d-flex align-items-center">s/d</span>
                            <b-form-input class="mr-2"
                                v-model="input.filterToDate" name="filterToDate"
                                type="date"
                            ></b-form-input>
                            <b-button class="mr-2" variant="pgiBtn" name="resetTableBtn" :disabled="isLoading" @click="onResetFilterTanggal">Reset</b-button>
                        </div>
                    </b-form-group>
                </div>
                <b-form-group label="Tipe Pinjaman">
                    <b-form-select v-model="input.tipePinjamanPeriode" name="tipePinjaman" :options="tipePinjamanOption" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>
            <div class="form-wrapper-btn">
                <b-button variant="pgiBtn" class="mr-2 download-btn" :disabled="isLoading" @click="confirmPeriodeWeb()">
                    Lihat di Web
                </b-button>
                <b-button variant="pgiBtn" class="download-btn" :disabled="isLoading" @click="confirmPeriodeDownload()">
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-tahunan-search" title="Laporan Tahunan" no-close-on-backdrop no-close-on-esc
            :hide-header-close="isSubmitting" hide-footer>
            <div class="form-content-wrapper mb-0">
                <b-form-group label="Tahun">
                    <b-form-select v-model="input.tahun" name="tahun" :options="tahunOption" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
                <b-form-group label="Tipe Pinjaman">
                    <b-form-select v-model="input.tipePinjamanTahun" name="tipePinjaman" :options="tipePinjamanOption" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>
            <b-button variant="pgiBtn" class="mr-2 download-btn" :disabled="isLoading" @click="confirmTahunanWeb()">
                Lihat di Web
            </b-button>
            <b-button variant="pgiBtn" class="download-btn" :disabled="isLoading" @click="confirmTahunanDownload()">
                <i class="fa fa-download mr-2"></i>
                Download Excel
            </b-button>
        </b-modal>
        <b-modal id="modal-periode-webPassword" content-class="lapeks-modal" @shown="focusPeriodeWebPassword" title="Confirm Web Laporan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="webPasswordForm" @submit.prevent="openPeriodeWeb">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordPeriodeWeb"
                        v-model="input.passwordPeriodeWeb"
                        name="passwordPeriodeWeb"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelWebPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeWebPasswordBtn" :disabled="isSubmitting" type="submit" form="webPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-periode-downloadPassword" content-class="lapeks-modal" @shown="focusPeriodeDownloadPassword" title="Confirm Download Laporan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="downloadExcelPasswordForm" @submit.prevent="openPeriodeDownload">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordPeriodeDownload"
                        v-model="input.passwordPeriodeDownload"
                        name="passwordPeriodeDownload"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelDownloadPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeDownloadPasswordBtn" :disabled="isSubmitting" type="submit" form="downloadExcelPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-tahunan-webPassword" content-class="lapeks-modal" @shown="focusTahunanWebPassword" title="Confirm Web Laporan Tahunan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="webTahunanPasswordForm" @submit.prevent="openTahunanWeb">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordTahunanWeb"
                        v-model="input.passwordTahunanWeb"
                        name="passwordTahunanWeb"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelWebPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeWebPasswordBtn" :disabled="isSubmitting" type="submit" form="webTahunanPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-tahunan-downloadPassword" content-class="lapeks-modal" @shown="focusTahunanDownloadPassword" title="Confirm Download Laporan Tahunan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="downloadTahunanPasswordForm" @submit.prevent="openTahunanDownload">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordTahunanDownload"
                        v-model="input.passwordTahunanDownload"
                        name="passwordTahunanDownload"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelDownloadPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeDownloadPasswordBtn" :disabled="isSubmitting" type="submit" form="downloadTahunanPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-excel" content-class="lapeks-modal" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'laporan-pemasukan',
    data(){
        return{
            isSubmitting: false,
            input:{
                jenisTipeLaporan: '',
                filterFromDate: null,
                filterToDate: null,
                passwordPeriodeDownload: "",
                passwordPeriodeWeb: "",
                //show web
                
                show: 10,
                filterCabang: null,
                tipePembayaranPeriode: 1,
                
                //
                tahun: null,
                passwordTahunanWeb: "",
                passwordTahunanDownload: "",
                tipePembayaranTahunan: 1,

                tipePinjamanTahun: null,
                tipePinjamanPeriode: null
            },
            isLoading: false,
            filePathDownload: "",
            query: "",
            //
            showWebPeriode: false,
            periodeStart: '',
            periodeEnd: '',
            isBusy: true,
            tipePembayaranOption: [
                {id: 1, name: 'Semua'},
                {id: 2, name: 'Perpanjangan'},
                {id: 3, name: 'Pelunasan'},
            ],
            tipePinjamanOption: [
                { value: 1, text: 'Elektronik'},
                { value: 2, text: 'BPKB'},
                { value: 3, text: 'Kendaraan'},
            ],
            fields: [
                { key: "cabangName", label: "Cabang"},
                { key: "jumlahTransaksi", label: "# Transaksi", sortable: true },
                { key: "jasa", label: "Jasa", sortable: true },
                { key: "admin", label: "Admin", sortable: true },
                { key: "denda", label: "Denda", sortable: true },
                { key: "penalti", label: "Penalti", sortable: true },
                { key: "keringanan", label: "Keringanan", sortable: true },
                { key: "totalPemasukan", label: "Total *", sortable: true },
                { key: "jasaAwal", label: "Jasa Awal", sortable: true},
                { key: "adminAwal", label: "Admin Awal", sortable: true},
                { key: "angsuranPokok", label: "Angsuran Pokok", sortable: true },
                { key: "pokok", label: "Pokok", sortable: true },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            dataPemasukanAll : {},
            showDataPemasukanAll : [],
            showDataPemasukan: [],
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            //
            periodeTahun: '',
            showWebTahunan: false,
            tahunOption: [],
            fieldTahunan: [
                { key: "cabangName", label: "Bulan"},
                { key: "jumlahTransaksi", label: "# Transaksi", sortable: true },
                { key: "jasa", label: "Jasa", sortable: true },
                { key: "admin", label: "Admin", sortable: true },
                { key: "denda", label: "Denda", sortable: true },
                { key: "penalti", label: "Penalti", sortable: true },
                { key: "keringanan", label: "Keringanan", sortable: true },
                { key: "totalPemasukan", label: "Total *", sortable: true },
                { key: "jasaAwal", label: "Jasa Awal", sortable: true},
                { key: "adminAwal", label: "Admin Awal", sortable: true},
                { key: "angsuranPokok", label: "Angsuran Pokok", sortable: true },
                { key: "pokok", label: "Pokok", sortable: true },
            ],
            showDataPemasukanTahunanAll: [],
            showDataPemasukanTahunan: [],
            dataPemasukanTahunanAll : {},
            
        }
    }, 
    watch: {
        "input.tipePembayaranPeriode": function(newValue) {
            if(newValue == 1){
                this.showDataPemasukanAll = this.dataPemasukanAll.total
                this.showDataPemasukan = this.dataPemasukanAll.total.entries
            }else if(newValue == 2){
                this.showDataPemasukanAll = this.dataPemasukanAll.pp
                this.showDataPemasukan = this.dataPemasukanAll.pp.entries
            }else{
                this.showDataPemasukanAll = this.dataPemasukanAll.pl
                this.showDataPemasukan = this.dataPemasukanAll.pl.entries
            }
            this.updateTotalItem()
            this.input.filterCabang = null
            this.perPage = 10
            this.currentPage = 1
        },
        "input.tipePembayaranTahunan": function(newValue) {
            if(newValue == 1){
                this.showDataPemasukanTahunanAll = this.dataPemasukanTahunanAll.total
                this.showDataPemasukanTahunan = this.dataPemasukanTahunanAll.total.entries
            }else if(newValue == 2){
                this.showDataPemasukanTahunanAll = this.dataPemasukanTahunanAll.pp
                this.showDataPemasukanTahunan = this.dataPemasukanTahunanAll.pp.entries
            }else{
                this.showDataPemasukanTahunanAll = this.dataPemasukanTahunanAll.pl
                this.showDataPemasukanTahunan = this.dataPemasukanTahunanAll.pl.entries
            }
        },
    },
    methods: {
		init(){
			var thisYear = new Date().getFullYear()
			for(var i = 2016; i <= thisYear; i++) {
				this.tahunOption.push(i)
			}
		},
        focusPeriodeWebPassword(){
            this.$refs.passwordPeriodeWeb.focus()
        },
        focusPeriodeDownloadPassword(){
            this.$refs.passwordPeriodeDownload.focus()
        },
        focusTahunanWebPassword(){
            this.$refs.passwordTahunanWeb.focus()
        },
        focusTahunanDownloadPassword(){
            this.$refs.passwordTahunanDownload.focus()
        },

        openLaporanPeriode(){
            this.$bvModal.show('modal-periode-search')
        },

        openLaporanTahunan(){
            this.$bvModal.show('modal-tahunan-search')
        },

        onResetFilterTanggal(){
            this.input.filterFromDate = null
            this.input.filterToDate = null
            this.showWebPeriode = false
        },

        confirmTahunanDownload(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.tahun)){
                this.$helper.toastErr(this, "Mohon isi tahun laporan!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjamanTahun)){
                this.$helper.toastErr(this, "Mohon isi tipe pinjaman!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openTahunanDownload()
                    this.input.passwordTahunanDownload = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-tahunan-downloadPassword')
                }
            }
        },

        openTahunanDownload(){
            this.showWebTahunan = false
            this.showWebPeriode = false
            this.isLoading = true
            this.$bvModal.hide('modal-tahunan-search')
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-tahunan-downloadPassword')
            setTimeout(() => { this.axiosTahunanDownload() }, 500)
        },

        axiosTahunanDownload(){
            this.$axios.get(`laporan-eksekutif/pemasukan-tahunan/dl?tahun=${this.input.tahun}&tipe=${this.input.tipePinjamanTahun}&password=${this.input.passwordTahunanDownload}`).then(response => {
                this.filePathDownload = response.data
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordTahunanDownload)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordTahunanDownload = ""
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.input.passwordTahunanDownload = ""
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmPeriodeDownload(){
            this.showWebTahunan = false
            this.showWebPeriode = false
            if(!this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) && (Date.parse(this.input.filterToDate) < Date.parse(this.input.filterFromDate))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjamanPeriode)){
                this.$helper.toastErr(this, "Mohon isi tipe pinjaman!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openPeriodeDownload()
                    this.input.passwordPeriodeDownload = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-periode-downloadPassword')
                }
            }
        },

        openPeriodeDownload(){
            this.isLoading = true
            this.$bvModal.hide('modal-periode-search')
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-periode-downloadPassword')
            setTimeout(() => { this.axiosPeriodeDownload() }, 500)
        },

        axiosPeriodeDownload(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)){
                this.query = `startDate=${this.input.filterFromDate}&tipe=${this.input.tipePinjamanPeriode}&password=${this.input.passwordPeriodeDownload}`
            }else{
                this.query = `startDate=${this.input.filterFromDate}&endDate=${this.input.filterToDate}&tipe=${this.input.tipePinjamanPeriode}&password=${this.input.passwordPeriodeDownload}`
            }
            this.$axios.get(`laporan-eksekutif/pemasukan/dl?${this.query}`).then(response => {
                this.filePathDownload = response.data
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordPeriodeDownload)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordPeriodeDownload = ""
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.input.passwordPeriodeDownload = ""
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmTahunanWeb(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.tahun)){
                this.$helper.toastErr(this, "Mohon isi tahun laporan!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjamanTahun)){
                this.$helper.toastErr(this, "Mohon isi tipe pinjaman!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openTahunanWeb()
                    this.input.passwordTahunanWeb = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-tahunan-webPassword')
                }
            }
        },

        openTahunanWeb(){
            this.showWebTahunan = true
            this.showWebPeriode = false
            this.isLoading = true
            this.$bvModal.hide('modal-tahunan-search')
            this.$bvModal.hide('modal-tahunan-webPassword')
            setTimeout(() => { this.axiosTahunanWeb() }, 500)
        },

        axiosTahunanWeb(){
            this.$axios.get(`laporan-eksekutif/pemasukan-tahunan?tahun=${this.input.tahun}&tipe=${this.input.tipePinjamanTahun}&password=${this.input.passwordTahunanWeb}`).then(response => {
                this.dataPemasukanTahunanAll = response.data
                this.showDataPemasukanTahunanAll = response.data.total
                this.showDataPemasukanTahunan = response.data.total.entries
                this.input.tipePembayaranTahunan = 1
                this.isLoading = false
                this.isBusy = false
                console.log(response.data)
                this.periodeTahun = this.input.tahun
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordTahunanWeb)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordTahunanWeb = ""
                let idxTipeLaporan= this.tipePinjamanOption.findIndex(item => item.value == this.input.tipePinjamanTahun)
                this.jenisTipeLaporan = this.tipePinjamanOption[idxTipeLaporan].text
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, error.response.data.reason)
                this.input.passwordTahunanWeb = ""
                this.showWebTahunan = false
                this.isLoading = false
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmPeriodeWeb(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) && (Date.parse(this.input.filterToDate) < Date.parse(this.input.filterFromDate))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjamanPeriode)){
                this.$helper.toastErr(this, "Mohon isi tipe pinjaman!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openPeriodeWeb()
                    this.input.passwordPeriodeWeb = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-periode-webPassword')
                }
            }
        },

        openPeriodeWeb(){
            this.showWebPeriode = true
            this.showWebTahunan = false
            this.isLoading = true
            this.$bvModal.hide('modal-periode-search')
            this.$bvModal.hide('modal-periode-webPassword')
            setTimeout(() => { this.axiosPeriodeWeb() }, 500)
        },

        axiosPeriodeWeb(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)){
                this.query = `startDate=${this.input.filterFromDate}&tipe=${this.input.tipePinjamanPeriode}&password=${this.input.passwordPeriodeWeb}`
            }else{
                this.query = `startDate=${this.input.filterFromDate}&endDate=${this.input.filterToDate}&tipe=${this.input.tipePinjamanPeriode}&password=${this.input.passwordPeriodeWeb}`
            }

            let getCabang = this.getOptionCabang()

            let getDataPemasukan = this.$axios.get(`laporan-eksekutif/pemasukan?${this.query}`).then(response => {
                this.dataPemasukanAll = response.data
                this.showDataPemasukanAll = response.data.total
                this.showDataPemasukan = response.data.total.entries
                this.input.tipePembayaranPeriode = 1
                this.updateTotalItem()
                this.perPage = 10
                this.currentPage = 1
                console.log(response.data)
                let idxTipeLaporan= this.tipePinjamanOption.findIndex(item => item.value == this.input.tipePinjamanPeriode)
                this.jenisTipeLaporan = this.tipePinjamanOption[idxTipeLaporan].text
            })

            Promise.all([getCabang, getDataPemasukan]).then(() => {
                this.input.filterCabang = null
                this.isLoading = false
                this.isBusy = false
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordPeriodeWeb)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordPeriodeWeb = ""
                this.periodeStart = this.input.filterFromDate
                if(this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)) {
                    this.periodeEnd = this.input.filterToDate
                }else{
                    this.periodeEnd = ""
                }
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, error.response.data.reason)
                this.input.passwordPeriodeWeb = ""
                this.showWebPeriode = false
                this.isLoading = false
            })
        },

        getOptionCabang(){
            if(this.cabangOption.length == 0){
                this.$axios.get("cabang/all-selection").then(response => {
                    response.data.forEach((element) => {
                        if(element.id != this.srcCabangId)
                            this.cabangOption.push(element)
                    })
                })
            }
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataPemasukan(){
            this.showDataPemasukan = this.showDataPemasukanAll.entries
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Aksi baris filter -----------------

        // Rentang tanggal diproses server, jadi Search mengambil ulang data.
        // Password diminta sekali, setelahnya dipakai ulang dari localStorage.
        onSearch(){
            this.confirmPeriodeWeb()
        },

        // Filter cabang murni sisi klien, langsung berlaku.
        onCabangChange(){
            if(!this.showWebPeriode) return
            if(this.input.filterCabang == null){
                this.onReset()
            }else{
                this.onFilter()
            }
        },

        onResetAll(){
            this.input.filterCabang = null
            this.onReset()
        },

        onReset(){
            this.input.filterCabang = null
            this.toggleBusy()
            this.getDataPemasukan()
        },
        
        onFilter(){
            
            if(this.input.filterCabang == null){
                this.$helper.toastErr(this, "Silakan isi nama cabang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.showDataPemasukanAll.entries) {
                    if(x.cabangId == this.input.filterCabang.id){
                        filteredArray.push(x)
                    }
                }
                
                this.showDataPemasukan = filteredArray
                this.onFiltered(this.showDataPemasukan)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.showDataPemasukan.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

	},
	created(){
        this.init()
    }
}
</script>


<style lang="scss" scoped>
// Design System Tokens (Deep Pine Palette)
$deep-pine: #023831;
$deep-pine-hover: #0A5247;
$brass: #C69B6B;
$ink-body: #16302B;
$ink-heading: #072D28;
$ink-muted: #7E918B;
$line-border: #E2E7E3;
$input-border: #D8E2DC;

.lapeks-page { padding-bottom: 30px; }

.filter-card,
.table-card {
    background-color: #FFFFFF;
    border: 1px solid $line-border;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.filter-card { padding: 22px 24px 24px; }
.table-card  { padding: 0; overflow: hidden; margin-bottom: 16px; }

.page-title {
    font-size: 20px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

// Label varian laporan di dalam kartu tabel
.table-card-label {
    position: relative;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: $ink-heading;
    padding: 18px 20px 12px 32px;
    margin: 0;
    border-bottom: 1px solid #EDF2EF;

    &::before {
        content: "";
        position: absolute;
        left: 20px;
        top: 19px;
        width: 3px;
        height: 13px;
        border-radius: 2px;
        background-color: $brass;
    }
}

// Filter
.filter-section {
    .filter-controls-row {
        display: flex;
        align-items: flex-end;
        gap: 12px;
        flex-wrap: wrap;
    }

    .filter-field {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .filter-sublabel {
        font-size: 11.5px;
        font-weight: 600;
        color: $ink-body;
    }

    .range-group {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .range-sep { font-size: 12px; color: $ink-muted; flex-shrink: 0; }

    ::v-deep .filter-input,
    .filter-select {
        height: 38px;
        border-radius: 8px;
        border: 1px solid $input-border;
        font-size: 13px;
        color: $ink-body;
        padding: 6px 14px;
        background-color: #FFFFFF;

        &::placeholder { color: #8C9F98; font-size: 12.5px; }

        &:focus {
            border-color: $deep-pine;
            box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
            outline: none;
        }
    }

    ::v-deep .filter-input.input-days { width: 110px; }
    .filter-select { padding: 6px 12px; width: 180px; max-width: 100%; }

    .filter-multiselect-wrapper {
        width: 220px;
        max-width: 100%;

        ::v-deep .multiselect {
            min-height: 38px;

            .multiselect__tags {
                min-height: 38px;
                height: 38px;
                padding: 6px 30px 0 12px;
                border-radius: 8px;
                border: 1px solid $input-border;
                background: #FFFFFF;
                font-size: 13px;
                color: $ink-body;
            }

            .multiselect__placeholder {
                margin-bottom: 0;
                padding-top: 2px;
                color: #8C9F98;
                font-size: 12.5px;
            }

            .multiselect__single {
                margin-bottom: 0;
                padding-top: 2px;
                font-size: 13px;
                color: $ink-body;
                line-height: 20px;
            }

            .multiselect__select { height: 36px; width: 32px; padding: 4px 6px; }

            &.multiselect--active .multiselect__tags {
                border-color: $deep-pine;
                box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
            }
        }
    }
}

.btn-filter-search {
    width: 40px;
    height: 38px;
    background-color: $deep-pine;
    border: 1px solid $deep-pine;
    color: #FFFFFF;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    transition: all 0.2s;

    &:hover:not(:disabled) { background-color: $deep-pine-hover; border-color: $deep-pine-hover; }
    &:disabled { opacity: 0.7; cursor: not-allowed; }
}

.btn-filter-reset {
    height: 38px;
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    font-size: 12.5px;
    font-weight: 500;
    padding: 6px 18px;
    border-radius: 8px;
    transition: all 0.2s;

    &:hover:not(:disabled) { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
}

.table-responsive-wrapper { overflow-x: auto; }

.custom-data-table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;

    ::v-deep thead th {
        background-color: #F6F7F6;
        border-top: none;
        border-bottom: 1px solid #ECEFEC;
        font-size: 11px;
        font-weight: 600;
        color: #7E918B;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding: 14px 20px;
        vertical-align: middle;
        white-space: nowrap;
    }

    ::v-deep tbody tr {
        transition: background-color 0.15s ease;

        &:hover { background-color: #F8FAF9; }

        td {
            padding: 16px 20px;
            border-top: 1px solid #EDF2EF;
            border-bottom: none;
            vertical-align: middle;
            font-size: 13px;
            color: $ink-body;
            font-weight: 500;
        }

        &:first-child td { border-top: none; }
    }
}

.table-pagination-footer {
    border-top: 1px solid #EDF2EF;
    padding: 16px 20px 4px;

    .limit-label { font-size: 12.5px; color: $ink-muted; }

    .limit-select {
        height: 32px;
        width: 70px;
        border-radius: 6px;
        border: 1px solid $input-border;
        font-size: 12.5px;
        color: $ink-body;
        padding: 2px 8px;
        background-color: #FFFFFF;
    }

    .entries-info { font-size: 12px; color: $ink-muted; }
}

.custom-pagination {
    ::v-deep .page-item {
        margin: 0 2px;

        .page-link {
            border-radius: 6px !important;
            border: 1px solid $input-border;
            color: $ink-body;
            font-size: 12px;
            font-weight: 500;
            min-width: 32px;
            height: 32px;
            padding: 0 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background-color: #FFFFFF;
            box-shadow: none !important;

            &:hover { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
        }

        &.active .page-link {
            background-color: $deep-pine !important;
            border-color: $deep-pine !important;
            color: #FFFFFF !important;
            font-weight: 700;
        }

        &.disabled .page-link {
            opacity: 0.45;
            background-color: #FAFCFA;
            border-color: #E2E7E3;
            color: #A0B0AA;
            cursor: not-allowed;
        }
    }
}

// Tombol Back pada halaman laporan cetak
.btn-back {
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    border-radius: 8px;
    font-size: 12.5px;
    font-weight: 600;
    padding: 7px 16px;
    transition: all 0.2s ease;

    &:hover { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
}
</style>
